var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"price-and-iso-in-table"},[_c('span',{staticClass:"gray1--text font-Regular-12 me-1"},[_vm._v(" "+_vm._s(_vm.$thousandMask(_vm.params.value))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }